import React from 'react';
import { render } from 'react-dom';
import { utils } from '../../utils';
import '../../utils/rcp';
import {
  timingMeasure,
  watermarkApi,
  logger,
  window,
  Wix,
  Consts,
  experimentsWrapper,
} from '@wix/photography-client-lib';
import { GalleryItem } from 'pro-layouts';
import _ from 'lodash';
import { storeApi, StoreBannerIntent } from '@wix/pro-gallery-artstore-statics';
import { HttpClient } from '@wix/http-client';
import { ProGalleryTPAWrapper } from '@wix/pro-gallery-tpa-wrapper';
import { serverItemsToProGallery } from '@wix/pro-gallery-items-formatter';

const httpClient = new HttpClient();
// wixFullstoryLoader({label: 'progallery-gallery'});

class ProGalleryServices {
  constructor() {
    this.initGallery = this.initGallery.bind(this);
    this.shouldUseNewApi = !utils.isStoreGallery(); // ARTSTORE does not work with new apis
    this.stopServerItemFetching = false;
    window._infiniteScrollUrl = window.infiniteScrollUrl;
    if (!utils.isInWix()) {
      const { testImages } = require('../test/images-mock');
      window.photos = this.testImages = testImages;
    }
    this.init();
  }

  init() {
    timingMeasure('ProGallery start', 'navigationStart');

    this.gallerySrcTypes = {
      // gallery source types
      sampleImages: 'sampleImages',
      itemsFromWixCode: 'itemsFromWixCode',
      prerenderedGallery: 'prerenderedGallery',
      albumSetFromBuilder: 'albumSetFromBuilder',
      manuallySetImages: 'manuallySetImages',
    };

    this.overridenStyleParams = {};
    this.bannerHeight = 0;

    this.populateGalleryData();

    this.content = window.document.getElementById('content');
    this.renderGallery();
  }

  updateServerMappingIfNeeded(setId, isDuringPublish, callback) {
    if (!isDuringPublish) {
      callback();
      return;
    }
    if (setId === 'fake_set') {
      callback();
      return;
    }

    if (
      this.mappingUpdatedInstanceId !== Wix.Utils.getInstanceId() &&
      (utils.getViewModeFromCache() === 'editor' ||
        utils.getViewModeFromCache() === 'preview') &&
      Wix.Utils.getDemoMode() === false
    ) {
      this.mappingUpdatedInstanceId = Wix.Utils.getInstanceId();
      // URL - http://progallery.wixapps.net/api/v1/albums/map-set-id
      // Body (json) {"instanceId" : "8e3502cb-25ee-4d7f-b8c3-96034fe36911", "compId" : "compId2", "setId": "75cda6bb-c060-4381-930a-beb9a22c027a"}
      const mappingData = {
        instanceId: Wix.Utils.getInstanceId(),
        compId: Wix.Utils.getCompId(),
        setId,
      };
      httpClient
        .request({
          method: 'POST',
          url: '/api/v1/albums/map-set-id',
          data: mappingData,
        })
        .then((res) => {
          if (res.data) {
            console.log('Success in mapping gallery to set', mappingData);
            callback();
          } else {
            console.error('Failed to map gallery to set', res);
            callback();
          }
        });
    }
  }

  getImagesFromBuilder() {
    if (utils.isDev()) {
      console.log('Gallery Services - getImagesFromBuilder');
    }

    if (window.document.domain !== 'wixapps.net') {
      try {
        // noinspection JSAnnotator
        window.document.domain = 'wixapps.net';
      } catch (e) {
        console.warn('Failed to set wix.com domain');
      }
    }

    // replace the current set of images on the window
    try {
      const activeAlbum = window.parent.parent['activeAlbum'];
      const albumSet = activeAlbum.getSetByGalleryId(Wix.Utils.getCompId()); // getSetByGalleryId is in albums code
      if (albumSet.id) {
        return albumSet.getSetJson(); // getSetJson is in albums code
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  populateGalleryData() {
    try {
      // replace the current set of images on the window

      let galleryData;
      let galleryDataSrcName;

      const albumSetFromBuilder = this.getImagesFromBuilder();
      if (window.manuallySetImages) {
        galleryData = window.manuallySetImages;
        this.galleryDataSrc = this.gallerySrcTypes.manuallySetImages;
        galleryDataSrcName = 'manuallySetImages';
      } else if (window.itemsFromWixCode) {
        galleryData = { photos: window.itemsFromWixCode };
        this.galleryDataSrc = this.gallerySrcTypes.manuallySetImages;
        galleryDataSrcName = 'itemsFromWixCode';
      } else if (albumSetFromBuilder) {
        galleryData = albumSetFromBuilder;
        this.galleryDataSrc = this.gallerySrcTypes.albumSetFromBuilder;
        galleryDataSrcName = 'albumSetFromBuilder';
      } else if (window.prerenderedGallery) {
        galleryData = { photos: window.prerenderedGallery.items };
        this.galleryDataSrc = this.gallerySrcTypes.prerenderedGallery;
        galleryDataSrcName = 'prerenderedGallery';
      } else {
        // no prerender gallery
        if (utils.isInWix() && utils.isSite() && !utils.isDev()) {
          console.error('prerendered gallery is missing');
          logger.log('pro_gallery_error', {
            errorType: 'prerenderedGalleryMissing',
          });
        }
        galleryData = { photos: this.testImages || [] };
        if (galleryData) {
          galleryData.renderedItemsCount = 50;
        }
        this.galleryDataSrc = this.gallerySrcTypes.sampleImages;
        galleryDataSrcName = 'testImages';
      }

      if (utils.isDev()) {
        console.log('Populating gallery data from: ' + galleryDataSrcName);
      }

      const _galleryData = (window.galleryData = galleryData);
      const _itemsCount =
        this.galleryDataSrc === this.gallerySrcTypes.prerenderedGallery
          ? window.prerenderedGallery.totalItemsCount
          : galleryData && galleryData.photos && galleryData.photos.length;

      if (!this.galleryData) {
        this.galleryData = _galleryData;
        this.itemsCount = _itemsCount;
      }
    } catch (e) {
      console.error('Could not populate gallery data', e);
    }
  }

  itemsToDto(items) {
    return _.map(items, (item) => {
      item.createdBy = 'itemsToDto';
      return new GalleryItem({ dto: item, watermark: this.watermarkData }).dto;
    });
  }

  getItemsDto() {
    let items = this.galleryData && this.galleryData.photos;
    items = items || [];
    return this.itemsToDto(items);
  }

  getAllItemsDto(callback) {
    const allCurrentItems = this.itemsToDto(
      this.galleryData && this.galleryData.photos,
    );
    if (!window.infiniteScrollUrl || this.stopServerItemFetching) {
      callback(allCurrentItems);
    } else {
      this.getAllItemsFromServer(callback);
    }
    return allCurrentItems;
  }

  getAllItemsFromServer(callback) {
    if (
      _.isUndefined(this.itemsCountToFetch) ||
      this.itemsCountToFetch === false
    ) {
      this.itemsCountToFetch = this.itemsCountToFetch || this.itemsCount;
    }
    if (this.shouldUseNewApi) {
      const step = 100;
      const itemsRequests = [];
      let items;
      // first request to get all the data
      this.getDataFromServer(0, 100).then((data) => {
        if (data && data.pageResponse) {
          this.itemsCountToFetch = data.pageResponse.totalItemsCount;
          items = data.pageResponse.items;
          if (this.itemsCountToFetch > 100) {
            for (let i = 100; i < this.itemsCountToFetch; i += step) {
              itemsRequests.push(this.getDataFromServer(i, i + step));
            }
            Promise.all(itemsRequests).then((res) => {
              res.forEach((elem) => {
                items = items.concat(...elem.pageResponse.items);
              });
              this.setImages(items);
              callback(items);
            });
          } else {
            this.setImages(items);
            callback(items);
          }
        }
      });
    } else {
      const step = 1000;
      const itemsRequests = [];
      for (let i = 0; i < this.itemsCountToFetch; i += step) {
        itemsRequests.push(this.getItemsFromServer(i, i + step));
      }
      this.itemsCountToFetch = false;

      Promise.all(itemsRequests).then((res) => {
        const items = [].concat(...res);
        this.setImages(items);
        callback(items);
      });
    }
  }

  formatServerGalleryResponse(serverGalleryResponseData) {
    const gallery =
      serverGalleryResponseData && serverGalleryResponseData.gallery;
    return !!gallery
      ? {
          dateCreated: gallery.created,
          galleryId: gallery.id,
          pageResponse: {
            totalItemsCount: gallery.totalItemsCount,
            items: serverItemsToProGallery(gallery.items),
          },
        }
      : {};
  }

  getDataFromServer(from) {
    const state = Wix.Utils.getDemoMode()
      ? Consts.dataSavedState.PUBLISHED
      : Consts.dataSavedState.SAVED;
    const url = `https://editor.wix.com/pro-gallery-webapp/v1/galleries/${window.galleryId}?offset=${from}&limit=100&state=${state}`;
    return httpClient
      .request({
        url,
        method: 'GET',
        headers: {
          // 'x-wix-linguist': getMultiLangHeader(),
          Authorization: window.instance,
        },
      })
      .then((res) => res.data)
      .then((data) => this.formatServerGalleryResponse(data))
      .catch((e) => {
        console.error(
          'Cannot fetch data from new server, PRG(galleryServices)' +
            '\n' +
            'url: ' +
            url +
            '\n' +
            'error: ' +
            e,
        );
        return {};
      });
  }

  getItemsFromServer(from, to) {
    if (this.shouldUseNewApi) {
      const state = Wix.Utils.getDemoMode()
        ? Consts.dataSavedState.PUBLISHED
        : Consts.dataSavedState.SAVED;
      const url = `https://editor.wix.com/pro-gallery-webapp/v1/galleries/${window.galleryId}?offset=${from}&limit=100&state=${state}`;
      return httpClient
        .request({
          url,
          method: 'GET',
          headers: {
            // 'x-wix-linguist': getMultiLangHeader(),
            Authorization: window.instance,
          },
        })
        .then((res) => res.data)
        .then((data) =>
          data ? serverItemsToProGallery(data.gallery.items) : [],
        )
        .catch((e) => {
          console.error('Cannot fetch items from new server', e);
          return [];
        });
    } else {
      const storeParameter = utils.isStoreGallery() ? '&isStore=true' : '';
      const url = `${window.infiniteScrollUrl}from/${from}/to/${to}?instance=${window.instance}${storeParameter}`; // APIREFACTOR done need to change. looks lke its used from media manager only(?)
      return httpClient
        .get(url, { withCredentials: true, xsrfCookieName: null })
        .then(({ data }) => data.items);
    }
  }

  isDisplayingDefaultImages() {
    try {
      const manuallySetImages = window.manuallySetImages;
      const albumSetFromBuilder = this.getImagesFromBuilder();
      const galleryFromVm = window.prerenderedGallery
        ? { photos: window.prerenderedGallery.items }
        : false;

      return !(manuallySetImages || galleryFromVm || albumSetFromBuilder);
    } catch (e) {
      console.error('Error checking if displaying default images', e);
      return false;
    }
  }

  resetImages() {
    if (utils.isDev()) {
      console.log('Gallery Services - resetImages');
    }
    try {
      this.galleryData = window.manuallySetImages = window.itemsFromWixCode = undefined;
      window.infiniteScrollUrl = window._infiniteScrollUrl; // diasble infinite scroll when setting images manually
      this.stopServerItemFetching = false;
      this.populateGalleryData();
      // note that after populateGalleryData, the items will be the prerenderedGallery items here
      // but, as mentioned in a comment in renderGallery, in this case the ProGalleryTPAWrapper will requests the correct items from the server by itself.
      this.renderGallery();
    } catch (e) {
      console.error('Cannot reset gallery images', e);
    }
  }

  setImages(images) {
    if (utils.isDev()) {
      console.log('Gallery Services - setImages', images);
    }
    // update selected images in the current set of images on the window
    if (typeof images !== 'object') {
      console.error('Trying to use addImages with illegal images', images);
    }
    if (!(images.length > 0)) {
      images = [images];
    }
    if (!this.galleryData) {
      this.populateGalleryData();
    }

    try {
      this.galleryData.photos = window.manuallySetImages = images;
      this.itemsCount = this.galleryData.photos.length;
      this.galleryDataSrc = this.gallerySrcTypes.manuallySetImages;
      window.infiniteScrollUrl = ''; // diasble infinite scroll when setting images manually //APIREFACTOR done- how to block if this is in new api?
      this.stopServerItemFetching = true; // new APIs

      if (!this.addedComponentDisconnectEvent) {
        Wix.addEventListener(
          Wix.Events.COMPONENT_DISCONNECT,
          this.resetImages.bind(this),
        );
        this.addedComponentDisconnectEvent = true;
      }
    } catch (e) {
      console.error('Cannot set new images', e, images, window);
    }

    // if (this.galleryView) {
    //   this.galleryView.renderTrigger = this.galleryView.renderTriggers.ITEMS; //this is a patch, we need to find a better way to control setState without predefined data
    //   this.galleryView.setState({items: this.galleryData.photos});
    // }
    this.renderGallery();
  }

  setAllImagesRemoved() {
    if (utils.isDev()) {
      console.log('Gallery Services - setAllImagesRemoved');
    }

    try {
      this.galleryData.photos = window.manuallySetImages = [];
      this.itemsCount = 0;
      this.galleryDataSrc = this.gallerySrcTypes.manuallySetImages;
    } catch (e) {
      console.error('Cannot set new images', e, window);
    }
    // if (this.galleryView) {
    //   this.galleryView.renderTrigger = this.galleryView.renderTriggers.ITEMS; //this is a patch, we need to find a better way to control setState without predefined data
    //   this.galleryView.totalItemsCount = this.itemsCount;
    //   this.galleryView.setState({items: this.galleryData.photos});
    // }
    this.renderGallery();
  }

  addImages(images, shouldAddToStart) {
    // update selected images in the current set of images on the window

    if (utils.isDev()) {
      console.log('Gallery Services - addImages', images, shouldAddToStart);
    }

    if (typeof images !== 'object') {
      console.error('Trying to use addImages with illegal images', images);
    }
    if (!this.galleryData) {
      this.populateGalleryData();
    }
    if (!(images.length > 0)) {
      images = [images];
    }

    let firstArray = this.galleryData.photos;
    let secondArray = images;

    if (shouldAddToStart) {
      firstArray = images;
      secondArray = this.galleryData.photos;
    }

    try {
      this.setImages(firstArray.concat(secondArray));
    } catch (e) {
      console.error('Cannot add new images', e, images, window);
    }
  }

  overrideStyleParams(styleParams) {
    try {
      this.overridenStyleParams = Object.assign(
        {},
        this.overridenStyleParams,
        styleParams || {},
      );
    } catch (e) {
      this.overridenStyleParams = {};
    }
    this.renderGallery();
  }

  reRenderGalleryForAlbums() {
    if (utils.isDev()) {
      console.log('Gallery Services - reRenderGalleryForAlbums');
    }

    this.populateGalleryData();
    // if (this.galleryView) {
    //   this.galleryView.renderTrigger = this.galleryView.renderTriggers.ITEMS; //this is a patch, we need to find a better way to control setState without predefined data
    //   this.galleryView.setState({items: this.galleryData.photos});
    // }
    this.renderGallery();
    // window.dispatchEvent(this.galleryScrollEvent);
  }

  initGallery() {
    if (utils.getViewModeFromCache() === 'editor' && utils.isStoreGallery()) {
      Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, (vm) => {
        if (vm.editMode === 'preview') {
          storeApi.getStoreGalleryData(true).then((data) => {
            if (utils.isDebugBuild()) {
              try {
                const currentConnectedProviders = this.getConnectedProviders();
                if (
                  Object.keys(currentConnectedProviders)[0] !==
                  Object.keys(data.connectedProviders)[0]
                ) {
                  console.log('Server providers is different than client');
                }
              } catch (error) {
                console.log(error);
              }
            }

            window.connectedProviders = data.connectedProviders;
          });
        }
      });
    }
  }

  enableStoreBanner(show) {
    if (show) {
      this.bannerHeight = utils.isMobile() ? 200 : 430;
    } else {
      this.bannerHeight = 0;
    }
    this.renderGallery();
  }

  renderGallery() {
    const renderGallery = () => {
      if (this.content && this.galleryData && this.galleryData.photos) {
        if (utils.isDev()) {
          console.log(
            'gallery Services renderGallery called',
            this.galleryData,
            this.itemsCount,
            this.store,
          );
        }

        // note that when galleryDataSrc !== manuallySetImages && !artStore, the ProGalleryTPAWrapper ignores the items that are passed in the props and is getting the items from the server by itself.
        let renderElement = (
          <ProGalleryTPAWrapper
            items={this.galleryData['photos']}
            galleryDataSrc={this.galleryDataSrc}
            offsetTop={this.bannerHeight}
            totalItemsCount={this.itemsCount}
            store={this.store}
            styles={this.overridenStyleParams}
            watermarkData={this.watermarkData}
            onInit={this.initGallery}
          />
        );

        const shouldShowGalleryBanner = utils.isStoreGallery();
        const bannerVisibility = this.bannerHeight > 0 ? 'visible' : 'hidden';
        if (shouldShowGalleryBanner) {
          renderElement = (
            <div style={{ width: 'auto', minWidth: '100%' }}>
              <div
                style={{
                  height: this.bannerHeight,
                  visibility: bannerVisibility,
                }}
              >
                <StoreBannerIntent
                  enableStoreBanner={(show) => this.enableStoreBanner(show)}
                />
              </div>
              {renderElement}
            </div>
          );
        }

        render(renderElement, this.content, () => {
          if (!utils.isSemiNative()) {
            window.document.getElementById('gallery-loader').className = '';
          }
        });
      } else {
        // in karma, this file is loaded but there is no window.document
        // console.error('Missing content element for react');
      }
    };

    if (utils.isStoreGallery()) {
      watermarkApi.getWatermarkData().then((watermarkData) => {
        this.watermarkData = watermarkData;
        renderGallery();
      });
    } else {
      this.watermarkData = {};
      renderGallery();
    }
  }
}

// this should not be accessed by anyone from the outside - everything should be done via post message
const proGalleryServices = (window.proGalleryServices = new ProGalleryServices());

window.addEventListener('message', (e) => {
  if (e && e.data === 'albumSetImagesUpdated') {
    proGalleryServices.reRenderGalleryForAlbums();
  }

  const { type, payload } = e.data;
  switch (type) {
    case 'renderGallery':
      proGalleryServices.renderGallery();
      break;
    case 'imageUpdated':
      proGalleryServices.reRenderGalleryForAlbums();
      break;
    case 'albumSetImagesUpdated':
      console.log('message albumSetImagesUpdated arrived for gallery ', e);
      proGalleryServices.reRenderGalleryForAlbums();
      break;
    case 'updateGallery':
      proGalleryServices.setImages(payload.items);
      break;
    case 'playgroundStylesUpdated':
      try {
        proGalleryServices.overrideStyleParams({ at: Date.now() }); // force styles update
      } catch (e) {
        console.error('cannot update playground styles', e);
      }
      break;
  }
});
